import { render } from "./WTheme.vue?vue&type=template&id=3b8e509a&ts=true"
import script from "./WTheme.vue?vue&type=script&lang=ts"
export * from "./WTheme.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__